export default "__VITE_ASSET__DrpTX2I1__"